import Swiper from 'swiper';
import 'swiper/css';
import 'swiper/css/navigation';
import { Navigation } from 'swiper/modules';
export default class BrandsSlider {
    constructor() {
        this.slider = document.querySelector('.swiper--component-brands');
        this.navigationPrev = document.querySelector('.slider-button-prev--component-brands');
        this.navigationNext = document.querySelector('.slider-button-next--component-brands');

        this.ready();
    }

    ready() {
        const swiper = new Swiper(this.slider, {
            modules: [Navigation],
            loop: true,
            grabCursor: true,
            slidesPerView: 2,
            spaceBetween: 24,
            allowTouchMove: true,
            navigation: {
                nextEl: this.navigationNext,
                prevEl: this.navigationPrev,
            },
            breakpoints: {
                640: {
                    slidesPerView: 2,
                    spaceBetween: 24,
                },
                1024: {
                    slidesPerView: 7,
                    spaceBetween: 24,
                },
            },
        });
    }
}
if (document.querySelector('.component-brands')) {
    new BrandsSlider();
}
